export const CONFIG = {
  baseUrl: 'https://api.trustpilot.com',
  id: '5fbc3e1b78da1f0001feb29d',
  params: {
    apikey: 'O7qWDbKtenIGhD83V0s7ExuqoC18ERsF',
    name: 'compareclub.com.au'
  }
}
